import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./index.scss";
// adapte ce chemin selon ton projet
import gif from "../../../assets/images/call.gif";
import { useNavigate } from "react-router-dom";
const CallToAction = () => {
  const navigate = useNavigate();
  return (
    <section className="call-to-action-section py-5">
      <div className="call-to-action-container">
        <div className="cta-box p-md-5 p-4">
          <Row className="align-items-center px-md-5 px-0">
            <Col md={6}>
              <h2 className="cta-title">
                Votre succès commence <br />
                <span>par un simple clic</span>
              </h2>
              <p className="cta-description mt-3">
                Chez Consultek, nous transformons vos ambitions en succès
                concrets grâce à notre expertise pluridisciplinaire et notre
                approche innovante.
              </p>
              <Button
                className="cta-button mt-3"
                onClick={() => {
                  navigate(`/contact#contact-section`);
                }}
              >
                Contactez-nous
              </Button>
            </Col>
            <Col md={1}></Col>
            <Col md={4}>
              <img src={gif} alt="Illustration" className="img-fluid" />
            </Col>
          </Row>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
